export default "TimeQuest åbnede helt tilbage i 2013, så de er det første og ældste escape room-firma i Danmark. ";